export enum Color {
  BLACK_BLUE = "#26547c",
  BLUE = "#0496ff",
  BROWN = "#4E2302D1",
  DARK_BLUE = "#002454",
  DARK_GREEN = "#288572",
  GRAY = "#2f2f2f",
  GREEN = "#34bb9c",
  LIGHT_BLUE = "#4798CA",
  MAGENTA = "#BE3455",
  ORANGE = "#FF6200B0",
  PINK = "#ef476f",
  PURPLE = "#b000d0",
  RED = "#ff0000b0",
  SKY_BLUE = "#93d6ff",
  WHITE = "#fffcf9",
  YELLOW = "#ffd166",
}
